import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { colors } from '../../../../config/colors';

const Search = ({ placeHolder, searchVal, setSearchVal, styles = {} }) => {
  const [localSearchVal, setLocalSearchVal] = useState(searchVal);
  const [searchTimeOut, setSearchTimeOut] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);
  const regexSpecialChars = [
    '.',
    '^',
    '$',
    '*',
    '+',
    '?',
    '{',
    '}',
    '[',
    ']',
    '\\',
    '|',
    '(',
    ')'
  ];

  useEffect(() => {
    if (isFocused) {
      inputRef.current.focus();
    }
  }, [isFocused]);

  const startSearchDebounce = (text) => {
    clearTimeout(searchTimeOut);
    setSearchTimeOut(
      setTimeout(() => {
        setSearchVal(encodeURIComponent(text));
      }, 1000)
    );
  };

  const handleSearch = () => {
    setSearchVal(encodeURIComponent(localSearchVal));
  };

  const handleSearchKeyDown = (e) => {
    if (e.keyCode === 13) {
      handleSearch();
    }
  };

  return (
    <div
      className={`relative flex items-center gap-2 justify-between w-full max-w-[35rem] lg:max-w-[29rem] transition-all duration-300 ease-in-out rounded-[25px] overflow-hidden ${
        isFocused ? 'shadow-lg' : ''
      } ${localSearchVal && !isFocused ? 'bg-white' : 'bg-white'} border border-gray-200`}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
    >
      <input
        ref={inputRef}
        type="text"
        className="flex-grow w-full h-12 px-4 pr-12 text-base text-gray-500 bg-transparent outline-none border-0 focus:ring-0"
        placeholder={placeHolder || 'Search here'}
        value={localSearchVal}
        onChange={(e) => {
          const text = e.target.value;
          if (regexSpecialChars.find((char) => text.includes(char))) {
            return;
          }
          setLocalSearchVal(text);
          startSearchDebounce(text);
        }}
        onKeyDown={handleSearchKeyDown}
      />
      <button
        onClick={handleSearch}
        className="absolute right-0 flex items-center justify-center w-12 h-12 transition-colors duration-200 hover:bg-gray-50"
      >
        <i 
          className={`flaticon-381-search-2 text-xl ${
            isFocused ? 'text-[#166473]' : 'text-gray-400'
          }`}
        />
      </button>
    </div>
  );
};

export default Search;
